import React, { useState, useEffect } from "react";
import { fetchMarketIndices, fetchMarketNews, fetchStockMovers } from "../models/marketsService";
import SectionHeader from "./SectionHeader";
import SparklineChart from "./SparklineChart";
import MarketGraph from "../components/MarketGraph";
import Card, { CardContent } from "./TakashiCard";
import { 
  fetchPrevClose,   // ✅ Fetches previous close prices (market indices)
  fetchTickerNews,  // ✅ Fetches market news
  fetchGainers,     // ✅ Fetches stock gainers
  fetchLosers       // ✅ Fetches stock losers
} from "../models/marketsService";


const Overview = (selectedDate) => {
  const [indices, setIndices] = useState([]);
  const [news, setNews] = useState([]);
  const [movers, setMovers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
      } catch (error) {
        console.error("Error fetching market overview data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="market-overview-container" id="overview-graph">
      {/* Market Indices Summary */}
      <MarketGraph selectedDate={selectedDate}/>
    </div>
  );
};

export default Overview;
